import { useEffect, useRef } from "react"
import { Input } from "@/components/ui/primitives"
import { UiRange } from "@/components/ui/ui-range"

type Props = {
  open: boolean
  width: number
  weightLabel: string
  onWidthChange: (width: number) => void
  onClose: () => void
  anchorRef: React.RefObject<HTMLElement | null>
}

export function SketchWidthFlyout({ open, width, weightLabel, onWidthChange, onClose, anchorRef }: Props) {
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => {
      const t = e.target as Node
      if (panelRef.current?.contains(t)) return
      if (anchorRef.current?.contains(t)) return
      onClose()
    }
    document.addEventListener("mousedown", onDoc)
    return () => document.removeEventListener("mousedown", onDoc)
  }, [open, onClose, anchorRef])

  if (!open) return null

  return (
    <div
      ref={panelRef}
      className="absolute top-full left-0 z-50 mt-1 w-56 rounded-lg border border-ui-border bg-ui-bg-elevated p-3 shadow-xl"
    >
      <label className="flex flex-col gap-1.5">
        <span className="text-[11px] font-medium text-ui-text-secondary">{weightLabel}</span>
        <div className="flex items-center gap-2">
          <UiRange
            min={1}
            max={64}
            value={width}
            className="min-w-0 flex-1"
            onChange={(e) => onWidthChange(Number(e.target.value))}
          />
          <Input
            type="number"
            min={1}
            max={64}
            value={width}
            className="h-8 w-12 px-1 text-center text-xs"
            onChange={(e) => onWidthChange(Math.min(64, Math.max(1, Number(e.target.value) || 1)))}
          />
        </div>
      </label>
    </div>
  )
}
